// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointIdFromJSON, DatapointIdToJSON, } from './';
export function DatapointAllowedDimensionsFromJSON(json) {
    return {
        'allowedDimensions': !exists(json, 'allowedDimensions') ? undefined : json['allowedDimensions'].map(DatapointIdFromJSON),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'datapoint': !exists(json, 'datapoint') ? undefined : DatapointIdFromJSON(json['datapoint']),
    };
}
export function DatapointAllowedDimensionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'allowedDimensions': value.allowedDimensions === undefined ? undefined : value.allowedDimensions.map(DatapointIdToJSON),
        'id': value.id,
        'datapoint': DatapointIdToJSON(value.datapoint),
    };
}
